// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-student[data-v-78df80c6] {\n  border-radius: 5px;\n  border-left: 5px solid #b5c3bc;\n  background-color: white;\n}\n.container-modal[data-v-78df80c6] {\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n}\n.pr-33-px[data-v-78df80c6] {\n  padding-right: 33px;\n}", ""]);
// Exports
module.exports = exports;
